var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TextField from "@mui/material/TextField";
import { Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { getOrganizationLanguages } from "../utils/useSupportedLanguages";
import { GeneralSet } from "../utils/generalSet";
import { getIconForLanguage, getNameForLanguage } from "../utils/translations.util";
import { useOrganization } from "../state/auth.reducer";
import { useState } from "react";
import { AiService } from "../services/ai/ai.service";
import { useTranslation } from "react-i18next";
import { AdminAIService } from "../services/identity/adminAI.service";
var LocalizedTextField = function (props) {
    var _a, _b;
    var organization = props.isAdmin ? props.organization : useOrganization();
    var supportedLanguages = (_a = props.forceLanguages) !== null && _a !== void 0 ? _a : getOrganizationLanguages(organization);
    var keys = new GeneralSet(Object.keys(props.value || {}));
    supportedLanguages.forEach(function (lang) { return keys.add(lang); });
    var t = useTranslation().t;
    var allKeysSorted = keys.values().sort(function (a, b) { return a.localeCompare(b); });
    var _c = useState(supportedLanguages[0] || allKeysSorted[0] || 'en'), selectedLanguage = _c[0], setSelectedLanguage = _c[1];
    var _d = useState(null), loadingLang = _d[0], setLoadingLang = _d[1];
    var findBaseLanguage = function () {
        var _a, _b, _c;
        var input = props.value || {};
        if ((_a = input["en"]) === null || _a === void 0 ? void 0 : _a.trim())
            return "en";
        if ((_b = input["de"]) === null || _b === void 0 ? void 0 : _b.trim())
            return "de";
        for (var _i = 0, supportedLanguages_1 = supportedLanguages; _i < supportedLanguages_1.length; _i++) {
            var lang = supportedLanguages_1[_i];
            if ((_c = input[lang]) === null || _c === void 0 ? void 0 : _c.trim())
                return lang;
        }
        return null;
    };
    var baseLang = findBaseLanguage();
    var handleTranslate = function (targetLang) { return __awaiter(void 0, void 0, void 0, function () {
        var text, response, _a;
        var _b;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!baseLang || targetLang === baseLang)
                        return [2 /*return*/];
                    text = (_c = props.value) === null || _c === void 0 ? void 0 : _c[baseLang];
                    if (!text || !text.trim())
                        return [2 /*return*/];
                    setLoadingLang(targetLang);
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, , 6, 7]);
                    if (!props.isAdmin) return [3 /*break*/, 3];
                    return [4 /*yield*/, AdminAIService.createTranslation(text, targetLang)];
                case 2:
                    _a = _d.sent();
                    return [3 /*break*/, 5];
                case 3: return [4 /*yield*/, AiService.createTranslation(text, targetLang)];
                case 4:
                    _a = _d.sent();
                    _d.label = 5;
                case 5:
                    response = _a;
                    props.onChange(__assign(__assign({}, props.value), (_b = {}, _b[targetLang] = response.translation, _b)));
                    return [3 /*break*/, 7];
                case 6:
                    setLoadingLang(null);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var value = ((_b = props.value) === null || _b === void 0 ? void 0 : _b[selectedLanguage]) || '';
    var hasValue = value.trim().length > 0;
    var isLoading = loadingLang === selectedLanguage;
    var translationDisabled = hasValue || !baseLang || selectedLanguage === baseLang;
    var tooltipText = !baseLang
        ? t("Fill at least one language first")
        : t("Auto-translate from filled language");
    return (_jsxs(Stack, __assign({ id: props.id, gap: 1, sx: { width: '100%' } }, { children: [_jsx(ToggleButtonGroup, __assign({ value: selectedLanguage, exclusive: true, onChange: function (_, newLang) { if (newLang !== null)
                    setSelectedLanguage(newLang); }, size: "small", sx: { gap: 0.5 } }, { children: allKeysSorted.map(function (lang) { return (_jsxs(ToggleButton, __assign({ value: lang, sx: { px: 1, py: 0.5, display: 'flex', alignItems: 'center', gap: 0.5 } }, { children: [_jsx("img", { alt: getNameForLanguage(lang), style: { width: '16px', height: '16px' }, src: getIconForLanguage(lang) }), _jsx("span", __assign({ style: { fontSize: '0.875rem' } }, { children: lang.toUpperCase() }))] }), lang)); }) })), _jsx(Stack, __assign({ direction: "row", alignItems: "center", gap: 1 }, { children: _jsx(TextField, { size: props.size, value: value, onChange: function (e) {
                        var _a;
                        return props.onChange(__assign(__assign({}, props.value), (_a = {}, _a[selectedLanguage] = e.target.value, _a)));
                    }, fullWidth: props.fullWidth, required: props.required, multiline: props.multiline, rows: props.rows, hiddenLabel: !props.label, label: props.label ? [props.label, getNameForLanguage(selectedLanguage)].filter(Boolean).join(' - ') : undefined, placeholder: !props.label ? getNameForLanguage(selectedLanguage) : undefined, disabled: props.disabled, inputProps: { 'data-testid': "".concat(props.id, "-").concat(selectedLanguage) } }) }))] })));
};
export default LocalizedTextField;
